import { assignDistance } from '../location-list';
import theme from '../../../src/js/modules/theme';

const locationCard = async () => {
  const cards = document.querySelectorAll('[js-location-card]');

  if(theme.locationAware(theme.brand()) === false) {
    return;
  }

  if (cards && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(position => {
      this.userLat = position.coords.latitude;
      this.userLng = position.coords.longitude;
      assignDistance(this.userLat, this.userLng);
    }, (e) => console.log(e));
  }
};

export default locationCard;
